// Generated from App.tsx for a single page build. Do not edit.
// Generated by the server from the registered pages. Do not edit.
import { Routes, Route, useLocation } from 'react-router-dom';
import OurApproachPage from "../pages/OurApproach/OurApproach";
const __wvcRoutePaths = ["/OurApproachPage", "/onze-aanpak"];
function AppRoutes() {
  const location = useLocation();
  const owned = new Set(["aboutuspage", "administratie", "administrationpage", "cases", "casespage", "contact", "contactpage", "finance", "financepage", "forwhopage", "home", "homepage", "hr", "humanresourcespage", "marketing", "marketingpage", "onze-aanpak", "operations", "operationspage", "ourapproachpage", "over-ons", "post", "voor-wie"]);
  const segment = (location.pathname.split('/')[1] || '').toLowerCase();
  return <Routes key={owned.has(segment) ? segment : '/'}>
      
      
      
      
      
      
      
      
      
      
      
      <Route path={__wvcRoutePaths[0]} element={<OurApproachPage />} />
      
      
      
      
      
      
      
      
      
      
      
      <Route path={__wvcRoutePaths[1]} element={<OurApproachPage />} />
    </Routes>;
}
function App() {
  return <>
      <AppRoutes />
    </>;
}
export default App;
